// React
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";

// @mui material components
import { Card, Fade, Icon, Modal, Tooltip } from "@mui/material";

import { gql, useQuery } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CustomPagination from "components/Pagination";
import Loading from "components/Carteles/Loading";
import DataTable from "components/Tables/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import dataPedidos from "./data/dataPedidos";
// import { ConfirmarContext } from "context/ConfirmarContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "90%", sm: "70%", xxl: "70%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalPedidos({ open, handleClose, selected }) {
  const [page, setPage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState({
    pages: 0,
    total: 0,
  });
  const [orderBy, setOrderBy] = useState({
    campo: "createdAt",
    orden: "DESC",
  });

  const {
    data,
    loading: loadingPedidos,
    refetch,
  } = useQuery(
    gql`
      query getPedidos($page: Int, $order: Order, $filter: JSON) {
        paginationInfo {
          pages
          total
        }
        pedidos(pagination: { page: $page, limit: 10 }, order: $order, filter: $filter) {
          id
          estado
          total
          createdAt
          fechaPedido
          detalles {
            id
            cantidad
            precio
          }
        }
      }
    `,
    {
      variables: {
        order: { field: orderBy.campo, order: orderBy.orden },
        filter: {
          cuentaCorriente: true,
          idCliente: selected?.id,
          pagado: false,
          _not: {
            estado: "ANULADO",
          },
        },
        page,
      },
      skip: !open || !selected?.id,
      fetchPolicy: "no-cache",
      cachePolicy: "no-cache",
    }
  );

  useEffect(() => {
    if (open && selected?.id) {
      refetch();
    }
  }, [open, selected?.id, orderBy, refetch]);

  const { columns, getRows } = dataPedidos;

  const handleOrderBy = (campo) => {
    if (orderBy.campo === campo) {
      if (orderBy.orden === "ASC") {
        setOrderBy({
          campo: campo,
          orden: "DESC",
        });
      } else {
        setOrderBy({
          campo: campo,
          orden: "ASC",
        });
      }
    } else {
      setOrderBy({
        campo: campo,
        orden: "ASC",
      });
    }
  };
  const allRows = useMemo(() => {
    if (data) {
      setPagesInfo(data.paginationInfo);
      return getRows(data.pedidos);
    }
  }, [data]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">{`Historial de pedidos ${
                  selected?.nombre + " " + selected?.apellido
                }`}</SoftTypography>
                <SoftTypography variant="caption" color="textSecondary">
                  Solo cuentas corrientes
                </SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox py={2}>
              {loadingPedidos ? (
                <Loading />
              ) : allRows?.length > 0 ? (
                <DataTable
                  columns={columns}
                  rows={allRows}
                  order={orderBy}
                  setOrder={handleOrderBy}
                />
              ) : (
                <SinDatos />
              )}
            </SoftBox>
            <CustomPagination
              loading={loadingPedidos}
              length={allRows?.length}
              total={pagesInfo?.total}
              pages={pagesInfo?.pages}
              page={page}
              setPage={setPage}
              noCard
            />
            <SoftBox display="flex" justifyContent="space-between" alignItems="center">
              <SoftBox
                mr={{
                  xs: 0,
                  sm: 2,
                }}
                mt={{
                  xs: 2,
                  sm: 0,
                }}
              >
                {/* <SoftButton
                  color="primary"
                  circular
                  onClick={handleClose}
                  fullWidth={{
                    xs: true,
                    sm: false,
                  }}
                >
                  <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                  &nbsp;Cerrar
                </SoftButton> */}
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalPedidos.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  selected: PropTypes.object,
};
